import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export default class isDraggable {
  constructor(element) {
    Draggable.create(element, {
      type: 'scrollLeft',
      cursor: 'pointer',
      autoScroll: 0,
      allowContextMenu: true,
    });
  }
}
